export enum PERMISSION {
    Pages = "Pages",
    Pages_Tenant_Dashboard = 'Pages.Tenant.Dashboard',

    // Incidents
    Pages_Incidents = 'Pages.Incidents',

    // Incident Reports
    Pages_IncidentReports = 'Pages.IncidentsReports',
    
    // Site List
    Pages_Site = "Pages.Site",
    Pages_Site_SiteList = 'Pages.Site.SiteList',
    Pages_Site_SiteMaps = 'Pages.Site.SiteMaps',
    
    // Live View
    Pages_LiveView = 'Pages.LiveView',
    Pages_LiveView_PTZControls = "Pages.LiveView.PTZControls",
    
    // Video Review
    Pages_VideoReview = 'Pages.VideoReview',

    // Service Tickets
    Pages_ServiceTickets = 'Pages.ServiceTickets',
    
    // Protocols
    Pages_Protocols = 'Pages.Protocols',

    // Contact Stealth
    Pages_ContactStealth = 'Pages.ContactStealth',

    // Customer Contacts
    Pages_CustomerContacts = 'Pages.CustomerContacts',
    
    // Administration
    Pages_Administration = 'Pages.Administration',

    // Roles
    Pages_Administration_Roles = "Pages.Administration.Roles",
    Pages_Administration_Roles_Create = "Pages.Administration.Roles.Create",
    Pages_Administration_Roles_Edit = "Pages.Administration.Roles.Edit",
    Pages_Administration_Roles_Delete = "Pages.Administration.Roles.Delete",

    // Users Permissions
    Pages_Administration_Users = "Pages.Administration.Users",
    Pages_Administration_Users_Create = "Pages.Administration.Users.Create",
    Pages_Administration_Users_Edit = "Pages.Administration.Users.Edit",
    Pages_Administration_Users_Edit_Role = "Pages.Administration.Users.Edit.Role",
    Pages_Administration_Users_Delete = "Pages.Administration.Users.Delete",
    Pages_Administration_Users_ChangePermissions = "Pages.Administration.Users.ChangePermissions",

    // Property Groups
    Pages_Administration_PropertyGroupUsers = "Pages.Administration.SiteGroupUsers",
    Pages_Administration_PropertyGroupUsers_Create = "Pages.Administration.SiteGroupUsers.Create",
    Pages_Administration_PropertyGroupUsers_Edit = "Pages.Administration.SiteGroupUsers.Edit",
    Pages_Administration_PropertyGroupUsers_Delete = "Pages.Administration.SiteGroupUsers.Delete",
    
    Pages_Administration_PropertyGroupSites = "Pages.Administration.PropertyGroupSites",
    Pages_Administration_PropertyGroupSites_Create = "Pages.Administration.PropertyGroupSites.Create",
    Pages_Administration_PropertyGroupSites_Edit = "Pages.Administration.PropertyGroupSites.Edit",
    Pages_Administration_PropertyGroupSites_Delete = "Pages.Administration.PropertyGroupSites.Delete",
    
    Pages_Administration_PropertyGroups = "Pages.Administration.PropertyGroups",
    Pages_Administration_PropertyGroups_Create = "Pages.Administration.PropertyGroups.Create",
    Pages_Administration_PropertyGroups_Edit = "Pages.Administration.PropertyGroups.Edit",
    Pages_Administration_PropertyGroups_Delete = "Pages.Administration.PropertyGroups.Delete",
}